import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageChange } from '../services/visitorTracking';

// Component to track route changes in React Router
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page change whenever location changes
    trackPageChange(location.pathname, document.title);
  }, [location]);

  return null; // This component doesn't render anything
};

export default RouteTracker;







